import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { useAuth } from "@airborne/react-admin";
import { TitleCoreInfoRequest } from "./Source";
import CustomerCoreInfoRequestEdit from "./CoreInfoRequestEdit/CustomerCoreInfoRequestEdit";
import TtCoreInfoRequestEdit from "./CoreInfoRequestEdit/TtCoreInfoRequestEdit";

/**
 * CoreInfoRequestEdit - Main orchestrator component
 *
 * This component routes to the appropriate edit component based on user type:
 * - Customer users: CustomerCoreInfoRequestEdit (editable fields based on selected reasons)
 * - TT users: TtCoreInfoRequestEdit (all technical fields disabled, can only edit reasons)
 */
const CoreInfoRequestEdit: FC<EditProps> = props => {
  const { user } = useAuth();

  return (
    <Edit {...props} title={TitleCoreInfoRequest.edit} component="div" hasShow={false}>
      {!user?.isCustomer ? <TtCoreInfoRequestEdit {...props} /> : <CustomerCoreInfoRequestEdit {...props} />}
    </Edit>
  );
};

export default CoreInfoRequestEdit;
